<div class="container-fluid bg-fondo p-5">
    <div class="justify-content-center">
      <p>Te invitamos a continuar con el proceso y seguir avanzando hacia tus sueños.</p>
      <p><strong>¿Deseas continuar con el proceso?</strong></p>
      <div class="button-position">
        <button class="btn response_no font-weight-bold" (click)="cancelProcess()">
            No
        </button>
        <button class="btn response_yes font-weight-bold" (click)="continueProcess()">
            Si
        </button>
      </div>
    </div>
</div>